import * as Sentry from "@sentry/react";
import { useCallback, useEffect, useState } from "react";

import Avatar from "../../../components/common/Avatar";
import ContractActions from "../../../components/contract/contractActions/ContractActions";
import { ESenderRole } from "../../../setup/api/services/contract/models";
import { getBasicUserDetailsById } from "../../../setup/api/services/user";
import {
  IUserInfoResponse,
  IUserInfoResponseData,
} from "../../../setup/api/services/user/models";
import { AuthConfig } from "../../../setup/context/config/authConfig";
import { PaymentDetails } from "../contractDetails/paymentDetails";
import { ReceiverInfo } from "../contractDetails/receiverInfo";
import Status from "../contractDetails/status/status";
import { IContractProps } from "../models";
import { HiddenDivider } from "./hiddenDivider";
// styles
import styles from "./styles.module.scss";

interface ILeftSection extends IContractProps {
  refreshContractDetails: any;
}

const LeftSection = ({ contract, refreshContractDetails }: ILeftSection) => {
  const [showChat, setShowChat] = useState<boolean>(false);
  const [currentChannelUrl, setCurrentChannelUrl] = useState<string>("");
  const [currentChannel, setCurrentChannel] = useState<any>(undefined);
  const [userDetails, setUserDetials] = useState<
    IUserInfoResponseData | undefined
  >(undefined);

  const userId = AuthConfig.getUserInfo().id;
  const getActorType = () => {
    if (contract.senderId == userId) return ESenderRole.PROVIDER;
    else return ESenderRole.CUSTOMER;
  };

  const fetchUserBasicInfo = useCallback(async () => {
    try {
      if (userId) {
        const response: IUserInfoResponse = await getBasicUserDetailsById(
          userId
        );
        if (response) {
          setUserDetials(response?.data);
        }
      }
    } catch (error) {
      Sentry.captureException(error);
      console.error(error);
    }
  }, [userId]);

  useEffect(() => {
    if (userId) {
      fetchUserBasicInfo();
    }
  }, [fetchUserBasicInfo, userId]);

  const toggleModal = useCallback(() => {
    setShowChat(!showChat);
  }, [showChat]);

  const displayUserInfo = () => {
    return !(
      getActorType() === ESenderRole.PROVIDER &&
      contract.senderId == userId &&
      !contract.receiverId
    );
  };

  return (
    <div className={styles.left_container}>
      {showChat && currentChannelUrl && currentChannelUrl !== "" ? (
        <>
          {userId && userId !== "" && (
            <div className={styles.chat_section}>
              <div className={styles.chat_header}>
                <div onClick={toggleModal} className={styles.back_section}>
                  <img src="/assets/images/svg/chatBack.svg" />
                </div>
                <div className={styles.profile_section}>
                  <Avatar
                    src={
                      getActorType() === ESenderRole.PROVIDER
                        ? contract?.customer?.profile?.photoUrl
                        : contract?.provider?.profile?.photoUrl
                    }
                  />
                  <p className={styles.subtitle2}>
                    {getActorType() === ESenderRole.PROVIDER
                      ? contract?.customer?.profile?.firstName
                      : contract?.provider?.profile?.firstName}
                  </p>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          <div className={styles.top_section}>
            <div>
              <Status contract={contract} actorType={getActorType()} />
            </div>
            <div className={styles.receiver_container}>
              {displayUserInfo() && (
                <ReceiverInfo contract={contract} toggleModal={toggleModal} />
              )}
            </div>
          </div>
          <HiddenDivider smUp />
          <div className={styles.bottom_section}>
            <div className={styles.paymentSection}>
              <PaymentDetails contract={contract} />
            </div>
            <ContractActions
              contract={contract}
              actorType={getActorType()}
              refreshContractDetails={refreshContractDetails}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default LeftSection;
